// extracted by mini-css-extract-plugin
module.exports = {"accordionButton":"accordionButton__FeJLr","icon":"icon__ta7iP"};